import Css from './Css.js';
import PlayLineImg from '../../Images/control_anchor.png';
import throttle from 'lodash.throttle';

function PlayLine(props){
  // const {
  //   dataInfo,
  //   pauseVideo,
  //   editorEl,
  //   selStartTime,
  //   selEndTime,
  //   progress,
  // } = props;
  // const videoInfo = dataInfo.videoInfo;
  // const videoEl = dataInfo.videoEl;
  // const middleWidth = dataInfo.middleWidth;
  const {videoEl,middleWidth,editorEl,selStartTime,selEndTime,progress} = props.data;
  const {pauseVideo} = props.method;

  const minLeft = 6;
  let marginLeft = 0;
  let progressWidth = middleWidth - 2*minLeft;
  let videoPregress = parseInt(videoEl.currentTime*1000);
  // if(videoInfo.progressPlayLineLeft){
  //   marginLeft = videoInfo.progressPlayLineLeft;
  // }else{
  //   let selTime = videoInfo.selEndTime - videoInfo.selStartTime;   
  //   marginLeft = parseInt(((videoPregress - videoInfo.selStartTime)/selTime)*progressWidth);
  // }
  let selTime = selEndTime - selStartTime;   
  marginLeft = parseInt(((videoPregress - selStartTime)/selTime)*progressWidth);

  //如果视频播放进度，不在滑轴选区范围内，则隐藏playLine
  let showPlayLine = "block";
  if(videoPregress < selStartTime){
    showPlayLine = "none";
  }
  if(marginLeft <= 0){
    marginLeft = 0;
  }
  //视频播放到时间选区最右侧则把播放线固定在最右侧
  if(marginLeft >= progressWidth && videoPregress <= (selEndTime + 300)){
    marginLeft = progressWidth;
  }
  //播放进度超出时间选区0.3s以上 则隐藏播放线
  let show = true;
  if(videoPregress > (selEndTime + 300)){
    show = false;
  }

  //播放进度滑动线条计算
  const onMouseDownPlayLine = (e)=> {
    pauseVideo();
    let prevX = e.clientX;
    editorEl.onmousemove = throttle(function(ev) {
      let moveDistanceX = parseInt(ev.clientX - prevX); //移动距离（即timeline缩短的长度）
      let selTime = selEndTime - selStartTime;
      let moveTime = (moveDistanceX/middleWidth)*selTime;
      let tcTime = (parseInt(progress + moveTime));
      if(tcTime >= selStartTime && tcTime <= selEndTime){
        videoEl.currentTime = parseInt(tcTime/1000);
      }else if(tcTime < selStartTime){
        videoEl.currentTime = parseInt(selStartTime/1000);
      }else if(tcTime > selEndTime){
        videoEl.currentTime = parseInt(selEndTime/1000);
      }
      
      editorEl.onmouseup = function(){
        editorEl.onmousedown = null;
        editorEl.onmousemove = null;
      };
      return false;
    }, 50);
  }

  return (
    <>
      {
        show ?
        <div style={ Css.PlayLine(marginLeft, showPlayLine) } onMouseDown={ (e)=>{ onMouseDownPlayLine(e) }}>
          <img alt="" src={ PlayLineImg } style={ Css.PlayLineImg }></img>
        </div> : ""
      }
    </>
  )
}

export default PlayLine;